import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import Table from "../../../components/Table/Table";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import styles from "../../../assets/jss/pages/listarHorarioAtendimentoStyle";
import ButtonFloat from "../../../components/ButtonFloat";
import FiltroHeader from "../../../template/Header/FiltroHeader";
import HeaderConfiguracoes from "../../../components/Header/HeaderConfiguracoes";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import { withRouter } from "react-router";
import { observer } from "mobx-react-lite";
import Notification from "../../../components/Notification";
import { columns, notificationDefault } from "./constants/constants";
import {
  findAllConfiguracaoHorarioAtendimento,
  findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude,
  findAllConfiguracaoHorarioAtendimentoSala,
} from "../../../services/ConfiguracaoHorarioAtendimentoService";
import { getProfissionalSaudeLogado } from "../../../services/UsuarioService";

const ListarHorarioAtendimento = observer(
  ({ history, location, filtroHeaderStore, classes }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [notification, setNotification] = useState(notificationDefault);
    const [pageNumber, setPageNumber] = useState(0);
    const [list, setList] = useState([]);
    const [last, setLast] = useState(false);

    const isAtendimento = location.pathname.includes("atendimento");
    const screen = isAtendimento
      ? "CONFIGURACAO_HORARIO_ATENDIMENTO"
      : "CONFIGURACAO_HORARIO_SALAS";
    const isProfissionalSaudeSelecionado = isAtendimento
      ? !!filtroHeaderStore.profissionalSaude
      : !!filtroHeaderStore.sala;

    useEffect(() => {
      filtroHeaderStore.sala = { nome: 'Selecione', id: '0' };

    }, []);

    useEffect(() => {
      isAtendimento
        ? loadConfiguracoesAtendimento({ isClearable: true })
        : loadConfiguracoesSala({ isClearable: true });
    }, [filtroHeaderStore.sala, filtroHeaderStore.profissionalSaude]);

    const getPageTitle = () => {
      const title = isAtendimento ? "Horário atendimento" : "Horário salas";

      return pageConfiguracoes(title);
    };

    const verificaFiltroSelecionado = () => {
      return isAtendimento
        ? !filtroHeaderStore.profissionalSaude?.id
        : !filtroHeaderStore.sala?.id;
    };

    const loadConfiguracoesAtendimento = async ({ isClearable }) => {
      try {
        if (isLoading) return;

        setIsLoading(true);

        const { unidadeId, profissionalSaudeId } =
          (await filtroHeaderStore.getFiltroAtual()) || {};

        const {
          showFiltroProfissionalSaude,
        } = await filtroHeaderStore.checkRoles(
          "CONFIGURACAO_HORARIO_ATENDIMENTO"
        );

        if (profissionalSaudeId === 0 && showFiltroProfissionalSaude) {
          throw new Error("É necessário selecionar um profissional de saúde.");
        }

        const profissionalSaudeAtual = await getProfissionalSaudeLogado();

        const query =
          profissionalSaudeAtual?.id !== profissionalSaudeId &&
          showFiltroProfissionalSaude
            ? findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude
            : findAllConfiguracaoHorarioAtendimento;

        const response = await query({
          searchDTO: {
            unidadeId,
            profissionalSaudeId,
            sortField: "dataInicioVigencia",
            sortDir: "DESC",
            pageSize: 30,
            pageNumber: isClearable ? 0 : pageNumber,
          },
        });

        const { last } = response || {};
        const content = response?.content || []

        setList(isClearable ? content : [...list, ...content]);
        setPageNumber(isClearable ? 1 : pageNumber + 1);
        setLast(last);
      } catch (e) {
        setNotification({
          open: true,
          message: "Erro ao carregar as configurações",
          type: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    const loadConfiguracoesSala = async ({ isClearable }) => {
      try {
        if (isLoading) return;

        setIsLoading(true);

        const { unidadeId, salaId } = await filtroHeaderStore.getFiltroAtual();

        if (salaId === '0' || !salaId) {
          return;
        }

        const response = await findAllConfiguracaoHorarioAtendimentoSala({
          searchDTO: {
            unidadeId,
            salaId,
          },
          pageableDTO: {
            sortField: "dataInicioVigencia",
            sortDir: "DESC",
            pageSize: 30,
            pageNumber: isClearable ? 0 : pageNumber,
          },
        });

        const { content, last } = response;

        setList(isClearable ? content : [...list, ...content]);
        setPageNumber(isClearable ? 1 : pageNumber + 1);
        setLast(last);
      } catch (e) {
        setNotification({
          open: true,
          message: "Erro ao carregar as configurações",
          type: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    const closeAlertMessage = () => {
      setNotification(notificationDefault);
    };

    const handleItemClick = (id) => {
      const configuracao = isAtendimento ? "atendimento" : "salas";

      history.push(`horario-${configuracao}/${id}/editar`);
    };

    return (
      <div className={classes.content}>
        <PageTitle title={getPageTitle()} />
        <HeaderConfiguracoes>
          <FiltroHeader screen={screen} />
        </HeaderConfiguracoes>
        <div className={classes.tableContainer}>
          {isProfissionalSaudeSelecionado ? (
            <>
              {!isLoading && list.length === 0 && (
                <div className={classes.notFoundContainer}>
                  <h3>Nenhum item encontrado</h3>
                </div>
              )}
              {list.length > 0 && (
                <Scroll
                  loadMore={() => isAtendimento ? loadConfiguracoesAtendimento({ isClearable: false }) : loadConfiguracoesSala({ isClearable: false })}
                  hasMore={!last}
                  pageStart={0}
                  initialLoad={false}
                >
                  <Table
                    id="cfg-lha-tbl-hor"
                    dados={list}
                    columns={columns}
                    clickable={true}
                    handleClick={handleItemClick}
                  />
                </Scroll>
              )}
              {isLoading && list.length === 0 && (
                <div className={classes.notFoundContainer}>
                  <CircularProgress />
                </div>
              )}
            </>
          ) : (
            <div className={classes.notFoundContainer}>
              <h3>
                {isAtendimento
                  ? "É necessário selecionar um profissional de saúde."
                  : "É necessário selecionar uma sala."}
              </h3>
            </div>
          )}
          <Link
            id="cfg-lha-lnk-cri"
            to={
              isAtendimento
                ? "horario-atendimento/criar"
                : "horario-salas/criar"
            }
          >
            <ButtonFloat id="cfg-lha-btn-nov" disabled={verificaFiltroSelecionado()} />
          </Link>
        </div>
        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.open}
          variant={notification.type}
          message={notification.message}
        />
      </div>
    );
  }
);

const ListarHorarioAtendimentoWithStyles = withRouter(
  withStyles(styles)(ListarHorarioAtendimento)
);
export default inject(
  "configuracaoHorarioAtendimentoStore",
  "filtroHeaderStore",
  "googleAnalyticsStore"
)(ListarHorarioAtendimentoWithStyles);
